import { computeCoverSize } from "components/Cover/CoverImage";
import { CoverProps } from "hardcover-ui/theme/components/cover";
import { enlargeUrl } from "lib/imageTools";

const covers = [
  "/static/covers/cover2.webp",
  "/static/covers/cover3.webp",
  "/static/covers/cover1.webp",
  "/static/covers/cover4.webp",
  "/static/covers/cover5.webp",
  "/static/covers/cover6.webp",
  "/static/covers/cover7.webp",
  "/static/covers/cover8.webp",
  "/static/covers/cover9.webp",
];

const coversLength = covers.length;

const RandomCover = ({
  id = 0,
  size,
  settings = {},
}: {
  id: number;
  size: CoverProps["size"];
  settings?: CoverProps["settings"];
}) => {
  const index = id % coversLength;
  const { height, width } = computeCoverSize({ size });
  const path = covers[index];

  const w2 = Math.round(width * 1.5);
  const h2 = Math.round(height * 1.5);

  const url1x = enlargeUrl({
    path,
    width,
    height,
  });
  const url2x = enlargeUrl({
    path,
    width: w2,
    height: h2,
  });

  return (
    <img
      className="rounded-md"
      alt={`Cover ${index}`}
      src={url1x}
      srcSet={`${url1x} ${width}w, ${url2x} ${w2}w`}
      width={width}
      height={height}
      loading={settings.eager ? "eager" : "lazy"}
    />
  );
};

export default RandomCover;
